<template>
  <td
    class="text-left beam-table-cell-select"
    @click="setFocus()"
    @keydown="keydownCell($event)"
  >
    <v-menu v-model="menu" scrim="true">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="{ ...filteredProps(props) }"
          :disabled="$store.state.isWorkflowDisabled"
          @keydown="menu ? keydownOpenMenu($event, props) : keydownButton($event)"
          @click="props.onClick"
          color="#DEEBFA"
          class="table-button">
          <div
            ref="cell"
            :tabindex="tab">
            {{ value ? value : '...' }}
          </div>
        </v-btn>
      </template>

      <v-list>
        <v-list-subheader>Select type:</v-list-subheader>
        <v-list-item
          @click.stop="handleClick"
          v-for="type in types"
          :key="type"
        >
          <v-list-item-action>{{ type }}</v-list-item-action>
        </v-list-item>
        <v-list-item @click="$emit('click-type', $event); menu = false">
          <v-list-item-action>...</v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </td>
</template>

<script>
export default {
  name: 'beam-table-cell-select',

  props: {
    value: String,
    types: Array,
    tab: Number
  },

  data () {
    return {
      menu: false
    }
  },

  methods: {
    filteredProps (props) {
      const { onKeydown, ...rest } = props // Remove onKeydown from the props
      return rest // Return the remaining props
    },
    keydownOpenMenu (event, props) {
      // return on escape
      if (event.keyCode === 27) {
        event.preventDefault()
        event.stopPropagation()
        this.menu = false
      }
      props.onKeydown(event)
    },
    keydownButton (event) {
      switch (event.keyCode) {
        case 13: // enter
        case 37: // left
        case 38: // up
        case 39: // right
        case 40: // down
          event.preventDefault()
          event.stopPropagation()
          this.$emit('leave-cell', event)
      }
    },
    keydownCell (event) {
      if (this.$store.state.isWorkflowDisabled) {
        return
      }

      switch (event.keyCode) {
        case 32: // space
          event.preventDefault()
          this.menu = !this.menu
      }
    },
    setFocus () {
      this.$refs.cell.focus()
    },
    handleClick ($event) {
      this.$emit('click-type', $event)
      this.menu = false
      this.$nextTick(() => {
        this.$refs.cell.focus()
      })
    }
  }

}
</script>

<style scoped>
.beam-table-cell-select {
  background-color: #DEEBFA;
  border-bottom: 1px solid #EDEAE8 !important;
}

.table-button {
  outline: none;
  padding: 0 0 !important;
  min-width: 40px !important;
}

.table-button div {
  outline: none;
}

.table-button:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: none;
}

</style>
